// Styles for Keyset component

export const checkboxCellContainer = {
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  padding: '8px',
  width: '100%',
};

export const checkbox = {
  cursor: 'pointer',
  height: '16px',
  width: '16px',
};

export const selectAllButton = {
  background: 'none',
  border: 'none',
  color: 'inherit',
  cursor: 'pointer',
  fontSize: 'inherit',
  textDecoration: 'underline',
};

export const buttonGroup = {
  display: 'flex',
  gap: '10px',
  justifyContent: 'flex-end',
};

export const buttonGroupWithDownload = {
  display: 'flex',
  gap: '10px',
  justifyContent: 'flex-end',
};

export const downloadButtonContainer = {
  marginRight: 'auto',
};

export const boldText = {
  fontWeight: 'bold',
};

export const tipBox = {
  backgroundColor: '#f5f5f5',
  borderRadius: '4px',
  padding: '10px',
};

export const greySection = {
  backgroundColor: '#f5f5f5',
  borderRadius: '4px',
  padding: '12px',
};

export const sectionMinHeight = {
  minHeight: '120px',
};

export const articleMinHeight = {
  minHeight: '80px',
};

export const inputWithZIndex = {
  zIndex: 1,
};

export const textAreaContainer = {
  minHeight: '100px',
};

export const textArea = {
  height: '60px',
  minHeight: '60px',
};

export const scheduleToggleContainer = {
  alignItems: 'center',
  display: 'flex',
  gap: '10px',
};

export const toggleLabel = {
  display: 'inline-block',
  height: '20px',
  position: 'relative',
  width: '36px',
};

export const toggleInput = {
  height: 0,
  opacity: 0,
  width: 0,
};

export const getToggleSlider = (isChecked) => ({
  backgroundColor: isChecked ? '#FA5400' : '#cccccc',
  border: 'none',
  borderRadius: '20px',
  bottom: 0,
  cursor: 'pointer',
  left: 0,
  position: 'absolute',
  right: 0,
  top: 0,
  transition: '0.4s',
});

export const getToggleKnob = (isChecked) => ({
  backgroundColor: '#FFFFFF',
  borderRadius: '50%',
  bottom: '3px',
  content: '""',
  height: '14px',
  left: '3px',
  position: 'absolute',
  transform: isChecked ? 'translateX(16px)' : 'translateX(0)',
  transition: '0.4s',
  width: '14px',
});

export const scheduleBanner = {
  alignItems: 'center',
  backgroundColor: '#f5f5f5',
  borderLeft: '4px solid #FA5400',
  borderRadius: '4px',
  color: '#FA5400',
  display: 'flex',
  gap: '10px',
  padding: '12px 16px',
};

export const clockIcon = {
  fontSize: '18px',
};
